/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { getCurrentPoolData } from '../../query/home/home.query'
import { noriCombinations } from '../../query/nori/nori.query'
import ScrollTop from '../../config/scroll'
import Header from '../../components/Header'
import Footer from '../../components/footer'
import Sidebar from '../../components/Sidebar'
import Loading from '../../components/Loader'
import FirstComponent from '../Nori/Step-Components/FirstComponent'
import SecondComponent from '../Nori/Step-Components/SecondComponent'
import ThirdComponent from '../Nori/Step-Components/ThirdComponent'
import FourthComponent from '../Nori/Step-Components/FourthComponent'
import FifthComponent from '../Nori/Step-Components/FifthComponent'
import SixthComponent from '../Nori/Step-Components/SixthComponent'
import SeventhComponent from '../Nori/Step-Components/SeventhComponent'
import EightComponent from '../Nori/Step-Components/EightComponent'
import NinthComponent from '../Nori/Step-Components/NinthComponent'

import '../../assets/sass/views/Nori.scss'
import '../../assets/sass/views/Home.scss'
import blueballimg from '../../assets/images/blue-ball-img.png'
import redballimg from '../../assets/images/red-ball-img.png'

const CompetitionNori = (props) => {
  const { t } = useTranslation('global')
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState({ status: true })
  const ticketState = state.ticketState
  const [currentPoolData, setCurrentPoolData] = useState(state.currentPoolData)
  const [noriPFactorData, setNoriPFactorData] = useState([])
  const [prevActiveStep, setPrevActiveStep] = useState(true)
  const [noriStatus, setNoriStatus] = React.useState({ status: 'inActive' })

  useEffect(() => {
    setTimeout(() => {
      setLoading({ status: false })
    }, 200)
  }, [])

  useQuery('current-pool', getCurrentPoolData, {
    select: (data) => {
      return data?.data
    },
    onSuccess: async (data) => {
      setCurrentPoolData(Object.assign(currentPoolData, data))
    },
    onError: () => {
      navigate('/error', { state: { errorMsg: 'Internal Server Error' } })
    }
  })

  const firstComponent = () => {
    return (
      <FirstComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} noriType={3} />
    )
  }
  const secondComponent = () => {
    return (
      <SecondComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const thirdComponent = () => {
    return (
      <ThirdComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const fourthComponent = () => {
    return (
      <FourthComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const fifthComponent = () => {
    return (
      <FifthComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const sixthComponent = () => {
    return (
      <SixthComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const seventhComponent = () => {
    return (
      <SeventhComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const eightComponent = () => {
    return (
      <EightComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} noriType={3} />
    )
  }
  const ninthComponent = () => {
    return (
      <NinthComponent
        steps={steps}
        noriStatus={noriStatus}
        setNoriStatus={setNoriStatus}
        setPrevActiveStep={setPrevActiveStep}
        npc={npc}
        noriPFactorData={noriPFactorData}
        setNoriPFactorData={setNoriPFactorData}
        noriType={3} />
    )
  }
  const [steps, setSteps] = useState([
    { id: 1, key: t('views.competitionNori.step') + '1', label: t('views.competitionNori.step1'), tooltip: t('views.competitionNori.stepDetails1'), isVisited: false, isDone: false, isSelected: true, component: firstComponent },
    { id: 5, key: t('views.competitionNori.step') + '5', label: t('views.competitionNori.step5'), tooltip: t('views.competitionNori.stepDetails5'), isVisited: false, selFilterCriteria: [{ id: 1, key: t('views.competitionNori.step51'), min: 0, max: 6, tooltip: t('views.competitionNori.stepDetails51') }, { id: 2, key: t('views.competitionNori.step52'), min: 0, max: 6, tooltip: t('views.competitionNori.stepDetails52') }, { id: 3, key: t('views.competitionNori.step53'), min: 0, max: 6, tooltip: t('views.competitionNori.stepDetails53') }, { id: 4, key: t('views.competitionNori.step54'), min: 0, max: 6, tooltip: t('views.competitionNori.stepDetails54') }, { id: 5, key: t('views.competitionNori.step55'), min: 0, max: 6, tooltip: t('views.competitionNori.stepDetails55') }, { id: 6, key: t('views.competitionNori.step56'), min: 0, max: 6, tooltip: t('views.competitionNori.stepDetails56') }], isDone: false, isSelected: false, component: fifthComponent },
    { id: 2, key: t('views.competitionNori.step') + '2', label: t('views.competitionNori.step2'), tooltip: t('views.competitionNori.stepDetails2'), isVisited: false, selectedNum: [], isDone: false, isSelected: false, component: secondComponent },
    { id: 6, key: t('views.competitionNori.step') + '6', label: t('views.competitionNori.step6'), tooltip: t('views.competitionNori.stepDetails6'), isVisited: false, selAdvanceFilterCriteria: [{ id: 1, key: t('views.competitionNori.step61'), min: 3, max: 40, dmin: 3, dmax: 40, tooltip: t('views.competitionNori.stepDetails61') }, { id: 2, key: t('views.competitionNori.step62'), min: 5, max: 41, dmin: 5, dmax: 41, tooltip: t('views.competitionNori.stepDetails62') }, { id: 3, key: t('views.competitionNori.step63'), min: 1, max: 37, dmin: 1, dmax: 37, tooltip: t('views.competitionNori.stepDetails63') }, { id: 4, key: t('views.competitionNori.step64'), min: 1, max: 5, dmin: 1, dmax: 5, tooltip: t('views.competitionNori.stepDetails64') }, { id: 5, key: t('views.competitionNori.step65'), min: 1, max: 5, dmin: 1, dmax: 5, tooltip: t('views.competitionNori.stepDetails65') }, { id: 6, key: t('views.competitionNori.step66'), min: 1, max: 6, dmin: 1, dmax: 6, tooltip: t('views.competitionNori.stepDetails66') }, { id: 7, key: t('views.competitionNori.step67'), min: 0, max: 10, dmin: 0, dmax: 10, tooltip: t('views.competitionNori.stepDetails67') }], tolerance: 0, tolTooltip: t('views.competitionNori.stepDetails68'), isDone: false, isSelected: false, component: sixthComponent },
    { id: 3, key: t('views.competitionNori.step') + '3', label: t('views.competitionNori.step3'), tooltip: t('views.competitionNori.stepDetails3'), isVisited: false, selectedExcludeNum: [], isDone: false, isSelected: false, component: thirdComponent },
    { id: 7, key: t('views.competitionNori.step') + '7', label: t('views.competitionNori.step7'), tooltip: t('views.competitionNori.stepDetails7'), isVisited: false, selAppPartiNum: [], quota: 6, isDone: false, isSelected: false, component: seventhComponent },
    { id: 4, key: t('views.competitionNori.step') + '4', label: t('views.competitionNori.step4'), tooltip: t('views.competitionNori.stepDetails4'), isVisited: false, selPriGrpNum: [], highPrio: 51, lowPrio: 49, isDone: false, isSelected: false, component: fourthComponent },
    { id: 8, key: t('views.competitionNori.step') + '8', label: t('views.competitionNori.step8'), tooltip: t('views.competitionNori.stepDetails8'), isVisited: false, selBlockWiseNum: [{ id: 1, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 2, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 3, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 4, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 5, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 6, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 7, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 8, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 9, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 10, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }], numOfBlocks: 2, isDone: false, isSelected: false, component: eightComponent },
    { id: 9, key: t('views.competitionNori.step') + '9', label: t('views.competitionNori.step9'), isVisited: false, isDone: false, isSelected: false, component: ninthComponent }
  ])
  const [activeStep, setActiveStep] = useState(steps[0])
  const [npc, setNpc] = useState({})
  const { refetch: refetches } = useQuery('nori-combinations', () => noriCombinations(steps), {
    enabled: false,
    select: (data) => {
      return data?.data
    },
    onSuccess: (data) => {
      data.rcb = data.rcb.toFixed(6)
      setNpc(Object.assign(npc, data))
    },
    onError: () => {
      navigate('/error', { state: { errorMsg: 'Internal Server Error' } })
    }
  })
  const handleNext = () => {
    console.log(ticketState)
    const result = [...steps]
    let index = [...steps, ...[]].sort((a, b) => a.id - b.id).find((x) => x.id > activeStep.id && x.isSelected === true)
    if (index === undefined) {
      refetches()
      index = result[8]
    } else {
      setSteps(prevStep => prevStep.map(x => {
        if (x.id === activeStep.id) {
          x.isDone = true
          x.isVisited = true
        }
        return x
      }))
    }
    if (activeStep.id === 9) navigate('/', { state: { ticketState: ticketState, currentPoolData: state?.currentPoolData } })
    setSteps(prevStep => prevStep.map(x => {
      if (x.id === activeStep.id) {
        x.isDone = true
        x.isVisited = true
      }
      return x
    }))
    setPrevActiveStep(true)
    setActiveStep(index)
    setLoading({ ...loading, status: true })
    setTimeout(() => {
      setLoading({ ...loading, status: false })
    }, 300)
  }
  const handleBack = () => {
    const index = [...steps, ...[]].sort((a, b) => b.id - a.id).find(x => activeStep.id - 1 > 1 && x.isSelected === false ? x.id === 1 : x.id < activeStep.id && x.isSelected === true)
    if (index === undefined) return navigate('/competition')
    setSteps(prevStep => prevStep.map(x => {
      if (x.id === activeStep.id) {
        x.isDone = true
        x.isVisited = true
      }
      return x
    }))
    setPrevActiveStep(true)
    setActiveStep(index)
    setLoading({ ...loading, status: true })
    setTimeout(() => {
      setLoading({ ...loading, status: false })
    }, 300)
  }
  const jumpToStep = (stepNo) => {
    const result = [...steps]
    const findEle = result.findIndex((a) => a.id === stepNo)
    setSteps(prevStep => prevStep.map(x => {
      if (x.id !== stepNo && x.id === activeStep.id) {
        x.isDone = true
        x.isVisited = true
      }
      return x
    }))
    setPrevActiveStep(true)
    setActiveStep(result[findEle])
    setLoading({ ...loading, status: true })
    setTimeout(() => {
      setLoading({ ...loading, status: false })
    }, 300)
  }
  return (
    <>
      {loading.status ? <Loading addClass={'active'} /> : ''}
      {prevActiveStep ? <ScrollTop /> : ''}
      <Header activeTab={1} tickets={ticketState} currentPoolData={currentPoolData} />
      <div className="stepper-sec">
        <Sidebar sideActiveTab={2} tickets={ticketState} currentPoolData={currentPoolData} />
        <div className="box">
          <img src={blueballimg} className='blueballimg' />
          <div className="step-component step-header">
            <div className='steps-left-sec left-header-sec'>
              <h1 className='pl-0'>{t('views.competitionNori.title')}</h1>
              <div className="steps">
                {/* {noriStatus.status === 'inActive' ? <span onClick={() => jumpToStep(1)}>Options</span> : <span>Options</span>} */}
                <span onClick={() => jumpToStep(1)}>{t('views.competitionNori.options')}</span>
                <ul className="nav">
                  {[...steps, ...[]].sort((a, b) => a.id - b.id).map((step, i) => {
                    return (
                      step.id < 9
                        ? <li key={step.id} className={activeStep.id !== 1 && activeStep.id === step.id && step.isVisited === false ? 'activate' : step.isDone ? 'done' : step.isSelected ? 'selected' : ''}>
                          {/* {step.isSelected && step.id !== 1 && noriStatus.status === 'inActive' ? <div onClick={() => jumpToStep(step.id)}><span><a >{step.id}</a></span></div> : <div><span>{step.id}</span></div>} */}
                          {step.isSelected && step.id !== 1 ? <div onClick={() => jumpToStep(step.id)}><span><a href=''>{step.id}</a></span></div> : <div><span>{step.id}</span></div>}
                        </li>
                        : ''
                    )
                  }
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="step-component">
            <div className='steps-left-sec'>
              {activeStep.component()}
              <img src={redballimg} className='redballimg' />
              <div className="btn-component">
                {/* {noriStatus.status !== 'active'
                ? <div>
                  <input type="button" value={ steps[0].id === activeStep.id ? 'Menu' : 'Prev'} onClick={handleBack}/>
                </div>
                : ''} */}
                <div>
                  <input type="button" value={steps[0].id === activeStep.id ? t('views.competitionNori.menu') : t('views.competitionNori.prev')} onClick={handleBack} />
                </div>
                <div><input type="button" value={steps[steps.length - 1].id !== activeStep.id ? t('views.competitionNori.next') : t('views.competitionNori.goBack')} onClick={handleNext} /> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer isVisibleBall={false} currentPool={state?.currentPoolData?.lastDraws} scoreDate={currentPoolData?.lastWiNs} graphData={state?.currentPoolData?.lastHundredDraws} />
    </>
  )
}

export default CompetitionNori
